import { Splitter, SplitterPanel } from 'primereact/splitter';
import { Dialog } from 'primereact/dialog';

import DocumentView from './DocumentView';

const DocumentsSplitView = (props) => {
    const { doc1, doc2 } = props
    const renderPDF = (pdfURL) => {
        return (
            <>
                {
                    pdfURL ?
                        <DocumentView fileUrl={pdfURL} showZoomControl={true} />
                        : <p>The pdf file is not found</p>
                }
            </>
        )
    }

    return (
        <Dialog header="" visible={props.visible} className='documents-split-view' style={{ width: '90vw', height: '85vh' }} onHide={() => props.onHide()}>
            <div style={{ height: 'calc(100vh - 100px)' }}>
                <Splitter style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                    <SplitterPanel style={{ width: '50%', height: '88%', overflow: 'auto' }}>
                        {renderPDF(doc1)}
                    </SplitterPanel>
                    <SplitterPanel style={{ width: '50%', height: '88%', overflow: doc2?.includes('.pdf') ? 'auto' : 'hidden' }}>
                        {doc2?.includes('.pdf') ? renderPDF(doc2) : <iframe title='pdf viewer' src={doc2} className='w-full h-full' />}
                    </SplitterPanel>
                </Splitter>
            </div>
        </Dialog>
    )
}

export default DocumentsSplitView